import { isSmartPhone } from './helper';

export const customizeTeamNameLogo = (title = '', shortName = '') => {
  switch (title) {
    case 'Indian Premier League': {
      switch (shortName) {
        case 'MI':
          shortName = 'MUM';
          break;
        case 'CSK':
          shortName = 'CHE';
          break;
        case 'DC':
          shortName = 'DEL';
          break;
        case 'KKR':
          shortName = 'KOL';
          break;
        case 'PBKS':
          shortName = 'PUN';
          break;
        case 'RR':
          shortName = 'RAJ';
          break;
        case 'RCB':
          shortName = 'BLR';
          break;
        case 'SRH':
          shortName = 'HYD';
          break;
      }
      break;
    }

    case 'Pro Kabaddi Season 8': {
      switch (shortName) {
        case 'Bengaluru':
          shortName = 'BLR';
          break;
      }
      break;
    }
  }

  return {
    shortName
  };
};

export const customizeLeagueTitle = (matchItem: any) => {
  const { formatString = '', competition = {}, homeTeam } = matchItem;
  const { title = '', cname = '' } = competition;
  let matchTitle = title ? title : cname;
  switch (matchTitle) {
    case 'Indian Premier League':
      matchTitle = 'Indian T-20 League';
      break;
    case 'Big Bash League':
      matchTitle = 'Australian T-20 League';
      break;
  }
  return homeTeam ? `${matchTitle}` : `${matchTitle}${!isSmartPhone ? ` (${formatString})` : ''}`;
};
